module.exports = "/images/ny-life1-15.jpg";